import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import Spinner from "./Spinner";
import { CODEMP_CREDITO_ARGENTINO, CODEMP_MUSIMUNDO } from "../utilities";



function Error({ message }) {
    const { codemp } = useSelector(state => state.adminReducer.login);
    const { paramsMus, errorEncrypt, stateError } = useSelector((state) => state.firstStep);
    const [isLoading, setIsLoading] = useState(false);

    const onRedirect = async () => {
        setIsLoading(true);
        if (CODEMP_MUSIMUNDO.includes(codemp)) {
            if (codemp === 2) {
                //ENTORNO PROD MUS
                return window.location.replace('https://seguros.emusimundo.com/webapi/platformWeb/cotizar/uUnX0N')
            } else {
                //ENTORNO TEST MUS
                return window.location.replace('https://test-seguros.emusimundo.com:9002/webapi/platformWeb/cotizar/2ggGvy');
            }
        } else if (CODEMP_CREDITO_ARGENTINO.includes(codemp)) {
            if (codemp === 1) {
                //ENTORNO PROD CFN
                return window.location.replace('https://seguros.emusimundo.com/webapi/platformWeb/cotizar/MVPF0K')
            } else {
                //ENTORNO TEST CFN
                return window.location.replace('https://test-seguros.emusimundo.com:9002/webapi/platformWeb/cotizar/nGEFNd');
            }
        }
    };


    useEffect(() => {
        localStorage.removeItem("url");
        localStorage.removeItem("test");
        if (errorEncrypt) {
            const tiempoEspera = 3000;
            const timer = setTimeout(onRedirect, tiempoEspera);
            return () => clearTimeout(timer);
        } else return;
    }, []);


    return (
        <>
            {
                !errorEncrypt ?
                    <Box>
                        <Box
                            display='flex'
                            justifyContent='center'
                            alignItems='center'
                            height='calc(100vh - 200px)'
                            sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
                            color='ed1c24'
                        >
                            <Typography variant='h1' component='h1' fontSize={50} fontWeight={200} style={{ color: "black", fontFamily: 'Monserrat' }}>404 |</Typography>
                            <Typography marginLeft={2} style={{ color: "black", fontFamily: 'Roboto' }}>{ message || 'Hubo un error inesperado'}</Typography>

                        </Box>
                        {
                            paramsMus.nro &&
                            <Box
                                display='flex'
                                justifyContent='center'
                                alignItems='center'
                                marginBottom={'20px'}
                            >
                                <Stack spacing={1} direction="row" justifyContent={'center'}>
                                    <Typography style={{ color: "black", fontFamily: 'Roboto' }}>Código:</Typography>
                                    <Typography marginLeft={1} style={{ color: CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue", fontFamily: 'Roboto' }}>{paramsMus.nro}</Typography>
                                </Stack>
                            </Box>
                        }
                        <Box>
                            {
                                isLoading &&
                                <Spinner />
                            }
                        </Box>
                    </Box>
                    :
                    <>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="calc(100vh - 200px)"
                            sx={{ flexDirection: "column" }}
                        >
                            <CircularProgress color="gray" />
                            <Typography marginLeft={2} style={{ color: "black", fontFamily: 'Roboto', marginTop: "15px" }}>Reconectando al sitio web. Aguarde un instante por favor.</Typography>
                        </Box>
                    </>
            }
        </>
    )

}

export default Error; 